import { useMemo } from 'react';
import { useParams } from 'react-router';
import useIsSale from '../../Common/_hooks/useIsSale';
import { productCatalogCollectionsBySlug } from '../Collections';
import { isProductCatalogCollectionActive } from '../Collections/ProductCatalogCollection';

export default function useSelectedProductCatalogCollection() {
  const params = useParams<{ category1?: string, category2?: string }>();
  const isSale = useIsSale();

  return useMemo(() => {
    if (params.category1 === undefined || params.category2 !== undefined) {
      return undefined;
    }

    const collection = productCatalogCollectionsBySlug.get(params.category1);
    if (collection === undefined || !isProductCatalogCollectionActive(collection, { isSale })) {
      return undefined;
    }

    return collection;
  }, [isSale, params.category1, params.category2]);
}
